module.exports = __webpack_public_path__ + "right-download-QRcode-e79e9b7e.jpg";